<template>
    <div>

        <div style="height:80px" :class="{ 'playMusicActive': packUpActive }" v-show="playMusic.id && packUpActive">
        </div>
        <div class="app">
            <div class="play_music bottomPlayMusic" :class="{ 'playMusicActive': packUpActive }" v-show="playMusic.id">
                <div class="packUp" @click="packUpActiveclick">
                    <i class="el-icon-d-arrow-right" :class="{ 'active': packUpActive }"></i>
                </div>
                <div class="music_audio">
                    <div class="music_img">
                        <el-image style="width: 64px; height: 64px;" :src="playMusic.url">
                            <div slot="placeholder" class="image-slot">
                                <el-skeleton style="width: 64px" animated>
                                    <template slot="template">
                                        <el-skeleton-item variant="image" style="width: 64px; height: 64px;" />
                                    </template>
                                </el-skeleton>
                            </div>
                        </el-image>
                        <img class="pause" src="../../assets/home/Group 755.png" v-if="!play" alt=""
                            @click.stop="handleplayMusic" @keydown.enter="handleplayMusic(false)">
                        <img class="pause" src="../../assets/home/play.png" v-else alt=""
                            @click.stop="handleplayMusic(true)" @keydown.enter="handleplayMusic">
                    </div>
                    <div class="music_info">
                        <marquee class="hidden" behavior="scroll" scrollamount="4"
                            v-if="$store.state.PutOnMusic.song_name && $store.state.PutOnMusic.song_name.length > 8"
                            v-html="$store.state.PutOnMusic.song_name"></marquee>
                        <p class="hidden" v-else v-html="$store.state.PutOnMusic.song_name"></p>
                        <span class="hidden">{{ playMusic.singer }}</span>
                    </div>
                    <!-- 音频曲线 -->
                    <div @click="handleLine('')" v-show="playMusic.id" class="audioLine_box">
                        <div ref="audioLine" class="audioLine"></div>
                    </div>
                    <div class="music_time">
                        <span>{{ currentTime }}/{{ duration }}</span>
                    </div>
                    <div class="music_tags">
                        <div :key="1" v-if="!playMusic.slices || playMusic.slices.length <= 1" class="music_tag_item" @click="toggle(1)" :class="{ 'active1': playMusicFlag == 1 }">
                            <span>原曲</span>
                        </div>
                        <template v-else>
                            <el-popover

                                ref="popover4"
                                placement="top"
                                trigger="hover">
                                <div>
                                    <el-button :class="{ 'active1': activeCurrentId == item.id + `${item.slice_type}` }" size="mini" v-for="(item,index) in playMusic.slices"  v-show="item.slice_type !== 1" @click="toggle(item.slice_type === 3 ? 1:2,item)" :key="index">
                                        <span>{{item.name}}</span>
                                    </el-button>
                                </div>
                                <div slot="reference" class="music_tags">
                                    <div :class="{ 'active1': activeCurrentId != isChorus.id + `${isChorus.slice_type}` }" class="music_tag_item">
                                        <span>{{songCurrentName}}</span>
                                    </div>
                                </div>
                            </el-popover>
                        </template>
                        <div v-if="isChorus" class="music_tag_item" :class="{ 'active1': activeCurrentId == isChorus.id + `${isChorus.slice_type}` }"  @click="toggle(2, isChorus )" >
                            <span>副歌</span>
                        </div>
                    </div>
                    <!-- 对音乐进行的一系列操作 -->
                    <div class="audio_operate">
                        <img src="@/assets/home/star.png" title="收藏" @click="collect(1)" v-if="collectIndex == 0"
                            alt="">
                        <img src="@/assets/home/collect.png" @click="collect(2)" title="取消收藏"
                            v-else-if="collectIndex == 1" alt="">
                        <!-- <img src="../../assets/home/star.png" alt=""> -->
<!--                        <img @click="download" src="../../assets/home/download.png" alt="">-->
                        <img src="../../assets/home/Union.png" alt="" title="加入购物车" @click="addCar"
                            v-if="!$store.state.PutOnMusic.isCart">
                        <img src="@/assets/home/cart-ac.png" alt="" @click="addCar" title="加入购物车" v-else>
                    </div>
                    <div class="music_pay" @click.stop="buyNow">
                        立即购买
                    </div>
                </div>
            </div>
        </div>
        <BuyNowVue ref="buyNow" :payChoose="payChoose" :bothPrices="bothPrices" :payPeices="payPeices"
            :bottomPay="bottomPay"></BuyNowVue>
        <!-- 用户认证的弹框 -->
        <certificationVue ref="certification"></certificationVue>
        <!-- 用户支付成功 -->
        <paySuccessVue ref="paySuccessVue"></paySuccessVue>
        <addShopCar :bothPrices="bothPrices" @newItemCartStatus="handleCartStatus" :goodsInfo="goodsInfo"
            ref="addShopCar" :carPeices="carPeices">
        </addShopCar>

    </div>
</template>

<script >

import WaveSurfer from 'wavesurfer.js' //导入wavesurfer.js
import BuyNowVue from '@/components/dialog/BuyNow.vue'
import certificationVue from '@/components/dialog/certification.vue'
import paySuccessVue from '@/components/dialog/paySuccess.vue'
import audioLineVue from './audioLine.vue'
import addShopCar from '@/components/dialog/addShopCar.vue'
import myMarque from './marque.vue'
import timeToMinute from '../../assets/js/minute'
import throttle from '../../assets/js/throttle.js'

export default {
    name: 'App',
    data() {
        return {
            songCurrentName:'原曲',
            activeCurrentId:'',
            percent: 0,
            config: {
                value: 0
            },
            // 未播放
            play: false,
            // 获取音频总时长
            duration: "00:00",
            currentTime: '00:00',//当前的时间
            packUpActive: true,
            carPeices: [],
            goodsInfo: {},
            payChoose: {},
            payPeices: [],
            bottomPay: 1,
            bothPrices: {},
            playMusicFlag: 1,//显示的是播放原曲还是副歌
            collectIndex: 0,
            wavesurfer: '',
            durationVal: 0
        };
    },
    computed: {
        playMusic() {
            return JSON.parse(JSON.stringify(this.$store.state.PutOnMusic))
        },
        //判断当前歌曲是否存在副歌
        isChorus(){
            let obj = null
            let slices = this.$store.state.PutOnMusic.slices || []
            if(slices.length){
                obj =  slices.find(item => item.slice_type === 1)
            }
            return obj
        }
    },
    beforeDestroy() {
        //这里的 this.login('loginForm') 指的是键盘事件的方法名
    },
    components: {
        BuyNowVue,
        certificationVue,
        paySuccessVue,
        audioLineVue,
        addShopCar,
        myMarque,
    },
    mounted() {
        this.init('audioLine')
        document.onkeydown = (e => {
            if (
                e.target.nodeName == "TEXTAREA" ||
                e.target.nodeName == "INPUT"
            ) {
                return;
            }
            if (e.code == 'Space') {
                if (this.wavesurfer) {
                    this.handleplayMusic()
                    e.preventDefault();
                }
            }
        })
        this.playMusicFlag = sessionStorage.getItem('refrain')
        this.collectIndex = this.$store.state.PutOnMusic.is_collection
    },
    methods: {
        // 获取音频总时长
        getDuration() {
            let time = parseInt(this.wavesurfer.getDuration());
            if (time) {
                console.log(time);
                this.duration = timeToMinute(time)
                this.durationVal = time
            }
        },

        // 获取时间
        getProcess() {
            if (this.wavesurfer) {
                this.wavesurfer.on('audioprocess', throttle((res) => {
                    this.currentTime = timeToMinute(Math.floor(res))
                    if (Math.floor(res) / this.durationVal < 1) {
                        this.$store.commit('SetPercentage', Math.floor(res) / this.durationVal)
                    } else {
                        this.currentTime = '00:00'
                    }
                }, 1000))
            }
        },
        init(name, waveform) {
            this.$nextTick(() => {
                this.wavesurfer = WaveSurfer.create({
                    container: this.$refs[name],
                    waveColor: '#DCDCDC',
                    progressColor: '#D92A20',
                    interact: true,
                    backend: 'MediaElement',
                    mediaControls: false,
                    audioRate: '1',
                    barGap: this.flag == 1 ? 2 : 1,
                    barRadius: 1,
                    height: 40,
                    cursorWidth: 0,
                    barWidth: 1,
                    scrollParent: false,
                    hideScrollbar: true,
                    cursor: 'pointer',
                });
                // // 播放结束
                this.wavesurfer.on('finish', res => {
                    this.$store.commit('SetPercentage', 1)
                    this.wavesurfer.seekTo(0)
                    this.$store.commit('setPause', true)
                    this.play = false
                })
                if (this.$store.state.PutOnMusicUrl) {
                    this.wavesurfer.load(this.$store.state.PutOnMusicUrl)
                    this.wavesurfer.on("waveform-ready", percents => {
                        this.getDuration()
                    });
                }
                // 播放开始
                this.wavesurfer.on('play', res => {
                    this.getProcess()
                    this.getDuration()
                    this.play = true
                    this.handleLine()
                })
            })
        },
        //购物车状态
        handleCartStatus(res) {
            if (res) {
                let store = this.$store.state.PutOnMusic
                store.isCart = res
                this.$store.commit('setPutOnMusic', store)
            }
        },
        //暂停播放当前歌曲
        endCurrentAudio() {
            this.$refs['audioLine'].wavesurfer.stop()
        },
        // 原曲和副歌
        toggle(type,item = null) {
            this.$store.commit('SetMouseLength', 0)
            let url;
            if(item){
                // 当前播放类型，原曲，伴奏，片那，id+slice_type 为了去重，分开伴奏和原曲
                this.activeCurrentId = item.id + `${item.slice_type}` ;
                if(item.slice_type !== 1){
                    this.songCurrentName = item.name;
                }
                url = this.$env.VUE_APP_URL + item.url;
            }else {
                url = type == 1 ? this.$store.state.PutOnMusic.watermark_url : this.$store.state.PutOnMusic.accompany_watermark_url

            }
            this.$store.commit('setPutOnMusicUrl', url)
            sessionStorage.setItem('refrain', type) //1是原曲，2是副歌
            this.playMusicFlag = type
        },
        async download() {
            // return
            if (!this.$store.state.user.id) {
                return this.$store.commit("setDialogVisible", true);
            }
            let val = this.$store.state.PutOnMusic
            let response = await fetch(val.watermark_url)
            // 内容转变成blob地址
            let blob = await response.blob()
            // 创建隐藏的可下载链接
            let objectUrl = window.URL.createObjectURL(blob)
            let a = document.createElement('a')
            //地址
            // // 障眼法藏起来a标签
            a.style.display = 'none';
            a.href = objectUrl
            //修改文件名
            a.download = val.song_name + '-' + val.singer
            // 触发点击
            document.body.appendChild(a)
            a.click()
            //移除
            setTimeout(() => document.body.removeChild(a), 1000)
        },
        addCar() {
            let val1 = {
                type: 0
            }
            this.$home.attribute(val1).then(res => {
                if (res.code == 200) {
                    this.bothPrices = res.data
                    let val = {
                        id: this.$store.state.PutOnMusic.id,
                        type: 1
                    }
                    // data.type = 1
                    this.goodsInfo = this.$store.state.PutOnMusic
                    this.goodsInfo.type = 1
                    this.goodsInfo.addCarMove = 1
                    this.$home.prices(val).then(res => {
                        if (res.code == 200) {
                            sessionStorage.setItem('collect', 1)
                            this.carPeices = res.data
                            this.$refs.addShopCar.addShopCar = true
                        }
                    }).catch(err => {
                    })
                }
            }).catch(err => {
            })

        },
        // 收藏
        collect(flag, idx) {
            sessionStorage.setItem('collect', 1)
            let data = {
                id: this.$store.state.PutOnMusic.id,
                type: 1
            }
            // return
            if (flag == 1) {
                this.$home.collection(data).then(res => {
                    if (res.code == 200) {
                        this.collectIndex = 1
                        let store = this.$store.state.PutOnMusic
                        store.is_collection = 1
                        this.$store.commit('setPutOnMusic', store)
                    }
                }).catch(err => {
                })
            } else {
                this.$home.cancelCollection(data).then(res => {
                    if (res.code == 200) {
                        this.collectIndex = 0
                        let store = this.$store.state.PutOnMusic
                        store.is_collection = 0
                        this.$store.commit('setPutOnMusic', store)
                    }
                }).catch(err => {
                })
            }
        },
        // 展开收起
        packUpActiveclick() {
            this.packUpActive = !this.packUpActive
        },
        // 立即购买
        buyNow() {
            // 正常弹出购买框
            let val = {
                type: 0
            }
            this.$home.attribute(val).then(res => {
                if (res.code == 200) {
                    this.bothPrices = res.data
                    let val1 = {
                        id: this.$store.state.PutOnMusic.id,
                        type: 1,//歌单1，歌曲2
                    }
                    // 立即购买的歌曲
                    this.payChoose = this.$store.state.PutOnMusic
                    // this.payChoose.url = this.payChoose.url
                    this.$home.prices(val1).then(res => {
                        if (res.code == 200) {
                            this.payPeices = res.data
                            this.$refs.buyNow.payDialogVisible = true
                        }
                    }).catch(err => {
                    })
                }
            }).catch(err => {
            })
        },
        handleplayMusic() {
            this.wavesurfer.playPause() //暂停时播放，播放时暂停
            this.play = !this.play
            let putOnMusic = this.$store.state.PutOnMusic
            putOnMusic.play = this.play
            this.$store.commit('setPutOnMusic', putOnMusic)

        },
        handleLine() {
            let putOnMusic = this.$store.state.PutOnMusic
            putOnMusic.play = true
            this.$store.commit('setPutOnMusic', putOnMusic)
        }
    },

    watch: {
        "$store.state.PutOnMusic": {
            deep: true,
            handler(val, old) {
                if(val.id !== old.id){
                    this.songCurrentName = '原曲';
                    if(val.slices && val.slices.length){
                        this.activeCurrentId = val.slices[0].id + `${val.slices[0].slice_type}`
                    }
                }
                if (val.id != old.id) {
                    this.playMusicFlag = 1
                    sessionStorage.setItem('refrain', 1) //1是原曲，2是副歌
                }
                this.play = val.play
                this.collectIndex = val.is_collection
                if (this.wavesurfer) {
                    if (val.play) {
                        this.wavesurfer.play() //暂停时播放，播放时暂停
                    } else {
                        this.wavesurfer.pause() //暂停时播放，播放时暂停
                    }
                }

            }
        },
        "$store.state.mouseLength"(val) {
            this.wavesurfer.seekTo(val) //点击页面中的音频曲线的时候跳转进度
        },
        "$store.state.PutOnMusicUrl": { //音频发生变化的时候重新加载
            deep: true,
            handler(val) {
                if (val) {
                    this.wavesurfer.load(val)
                    this.$store.commit('setPause', false)
                    this.wavesurfer.on("waveform-ready", percents => {
                        this.wavesurfer.play()
                        this.wavesurfer.seekTo(this.$store.state.mouseLength) //点击页面中的音频曲线的时候跳转进度
                    });
                }
            }
        }
    }
}
</script>


<style lang="scss" scoped>
.audioLine_box {
    width: 500px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.audioLine {
    width: 440px;
    height: 40px;
}

#waterform {
    overflow: hidden;
}

.box-card {
    width: 100%;
}

::v-deep .dv-percent-pond svg text {
    fill: #000000;
    stroke: #000000;
}

.bottomPlayMusic {
    max-height: 0;
    // overflow: hidden;
    transition: .7s;
}

.playMusicActive {
    max-height: 100px;
}





.play_music {
    width: 100%;
    position: fixed;
    bottom: 0;
    background-color: white;
    z-index: 9;
    background-attachment: fixed;
    background: rgba(255, 249, 249, 0.55);
    backdrop-filter: blur(90px);
    .packUp {
        position: absolute;
        text-align: center;
        top: -30px;
        right: 160px;
        cursor: pointer;
        z-index: 1999;
        width: 30px;
        height: 30px;
        line-height: 30px;
        color: gray;
        box-shadow: 0 0 10px 1px rgba(0, 0, 0, .15);
        // height: 0;
        border-radius: 8px 8px 0 0;
        border-radius: 50%;
        // border-color: transparent transparent #ffffff;
        // border-style: none solid solid;
        // border-width: 0 2px 18px;
        font-size: 14px;

        i {
            transform: rotate(270deg);
            transition: .7s;
        }

        .active {
            transform: rotate(90deg);
        }
    }

    .music_audio {
        width: 1200px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        height: 80px;
        position: relative;

        .music_img {
            position: relative;
            display: flex;
            justify-content: center;
            align-items: center;

            .pause {
                width: 30px;
                height: 30px;
                position: absolute;
                cursor: pointer;
            }
        }

        .music_info {
            margin-left: 16px;
            text-align: left;

            marquee {
                font-size: 18px;
                font-family: PingFang SC-Semibold, PingFang SC;
                font-weight: 600;
                color: #333333 !important;
                // line-height: 14px;
                margin-bottom: 5px;
                width: 100px;

                span {
                    color: #333333 !important;
                }
            }

            p {
                font-size: 18px;
                font-family: PingFang SC-Semibold, PingFang SC;
                font-weight: 600;
                color: #333333 !important;
                // line-height: 14px;
                margin-bottom: 5px;
                width: 100px;
            }

            span {
                font-size: 14px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #999999;
                width: 100px;
            }
        }

        .music_audio_line {
            margin: 0 30px 0 70px;
            width: 440px;

            img {
                width: 440px;
                height: 40px;
            }

        }

        .music_time {
            font-size: 14px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            line-height: 14px;
        }

        .audio_operate {
            margin-left: 25px;
            display: flex;
            // grid-column-gap: 20px;

            img {
                cursor: pointer;
                margin-right: 20px;
            }
        }

        .music_pay {
            width: 84px;
            height: 32px;
            border-radius: 3px 3px 3px 3px;
            opacity: 1;
            border: 1px solid #D92A20;
            font-size: 14px;
            font-family: PingFang SC-Semibold, PingFang SC;
            font-weight: 600;
            color: #D92A20;
            display: flex;
            justify-content: center;
            align-items: center;
            position: absolute;
            cursor: pointer;
            right: 0;

            &:hover {
                background-color: #D92A20;
                color: white;
            }
        }
    }
}
</style>
<style lang="scss">
.music_tags {
    display: flex;
    align-items: center;
// grid-column-gap: 10px;

    margin-left: 30px;

    >div {
        margin-left: 10px;
        padding: 5px 13px;
        cursor: pointer;
        text-align: center;
        border-radius: 3px 3px 3px 3px;
        opacity: 1;
        border: 1px solid #CCCCCC;
        font-size: 14px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        line-height: 24px;
        color: #666666;
        display: flex;
        justify-content: center;
        align-items: center;

        &:hover {
            border-color: #D92A20;
            color: #D92A20;
        }
    }
}
 .active1{
     color: #D92A20!important;
     border-color: #D92A20!important;
 }
</style>
